import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Box,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import ColorData from "../CstmTheme/ColorData";
import ImgPath from "../../Constants/Imgs";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { useSelector } from "react-redux";
import { UserInitialStateType } from "DataTypes/Redux";
import LanguageSelector from "Components/commonComponents/LanguageSelector";
import React from "react";
import DesktopNav from "Components/commonComponents/DesktopNav ";
import MenuList from "Components/commonComponents/MenuList";
import { Admin_Number } from "Utils/Common";
import MobileDrawer from "Components/commonComponents/HederDrawer";
import dayjs from "dayjs";

// Navigation handler function
export const handleNavigation = (item: string) => {
  switch (item) {
    // Legal Services
    case "Legal Notice- Send and Reply":
      window.location.href = "/legal-notice.html";
      break;
    case "Legal Drafting":
      window.location.href = "/legal-drafting.html";
      break;
    case "Legal Document Review":
      window.location.href = "/legal-review.html";
      break;
    case "File or Defend a Case":
      window.location.href = "/file-a-case.html";
      break;
    case "Talk to a Lawyer":
      window.location.href = "/online-legal-consultation.html";
      break;

    // Legal Finance
    case "Third Party Litigation Funding":
      window.location.href = "/third-party-litigation-funding-support.html";
      break;

    // ODR
    case "Online Mediation":
      window.location.href = "/mediation-online-dispute-resolution.html";
      break;
    case "Online Arbitration":
      window.location.href = "/arbitration-online-dispute-resolution.html";
      break;

    // Talk with Expert
    case "Talk to a Chartered Accountant":
      window.location.href = "/online-ca-consultation.html";
      break;
    case "Talk to a Company Secretary":
      window.location.href = "/chartered-secretary-cs.html";
      break;

    // Start-up Support
    case "Incorporate your Business":
      window.location.href = "/incorporate-your-business.html";
      break;
    case "Start-up Tool Kit":
      window.location.href = "/start-up-toolkit.html";
      break;
    case "Fund Raising":
      window.location.href = "/fund-raising.html";
      break;
    case "DPDP Compliance":
      window.location.href = "/drdp-compliance.html";
      break;
    case "Pitch Deck":
      window.location.href = "/investment-pitch-deck-for-start-up-owners.html";
      break;
    case "Due-Diligence":
      window.location.href = "/due-diligence-for-investment.html";
      break;
    case "Virtual Legal Counsel":
      window.location.href = "/legal-manager.html";
      break;
    case "Website Development Services":
      window.location.href = "/website-development-service.html";
      break;
    case "Posh Compliance":
      window.location.href = "/posh-compliance-support.html";
      break;

    // Business Registration
    case "Register Private Limited Company":
      window.location.href = "/register-private-limited-company.html";
      break;
    case "Register Limited Liability Partnership (LLP)":
      window.location.href = "/register-llp.html";
      break;
    case "Register Subsidiary Company":
      window.location.href = "/register-indian-subsidiary-company-online.html";
      break;
    case "Register Producer Company":
      window.location.href = "/producer-company.html";
      break;
    case "Register One Person Company":
      window.location.href = "/register-one-person-company-online.html";
      break;
    case "Register Nidhi Company":
      window.location.href = "/register-nidhi-comany.html";
      break;
    case "Register Sole Proprietorship":
      window.location.href = "/register-sole-propritorship.html";
      break;
    case "Register Partnership":
      window.location.href = "/register-partnership-firm-online.html";
      break;

    // For Investors
    case "Alternative Fund Incubation":
      window.location.href = "/alternative-fund-incubation-for-investor.html";
      break;
    case "Investment Execution Advisory":
      window.location.href = "/investment-execution-and-advisory-for-investors.html";
      break;
    case "Investment Transaction Life Cycle":
      window.location.href = "/investment-transaction-Life-Cycle-Management-for-investors.html";
      break;
    case "Exit Support and Compliance":
      window.location.href = "/exist-support-and-compliance-for-investor.html";
      break;

    // Tax & Compliance
    case "Income Tax Return Filling":
      window.location.href = "/income-tax-return-filing.html";
      break;
    case "TDS Return Filling":
      window.location.href = "/tds-return.html";
      break;
    case "GST Registration Online":
      window.location.href = "/gst-registration-online.html";
      break;
    case "GST Filling Online":
      window.location.href = "/gst-filling-online.html";
      break;
    case "Annual Accounting services":
      window.location.href = "/annual-complaiance-services.html";
      break;
    case "Licenses and Registration":
      window.location.href = "/licenses-and-registration.html";
      break;
    case "Changes in Private Limited Company":
      window.location.href = "/changes-private-limited-company.html";
      break;
    case "Changes in LLP":
      window.location.href = "/changes-limited-liability-partnership.html";
      break;
    case "Business Entity Conversion":
      window.location.href = "/business-enity-covesion.html";
      break;
    case "Secretarial Audit":
      window.location.href = "/secretarial-audit.html";
      break;
    case "Register Copyright":
      window.location.href = "/register-copyright.html";
      break;
    case "Register Patent":
      window.location.href = "/register-patent-online.html";
      break;
    case "Register Trademark":
      window.location.href = "/register-trademark.html";
      break;
    case "Register your Design":
      window.location.href = "/Register_your_Design.html";
      break;
    case "IP-Infringement":
      window.location.href = "/infringement-Intellectual-property-works.html";
      break;

    // Other Services
    case "NGO Registration and Compliance":
      window.location.href = "/register-ngo.html";
      break;
    case "File RTI Application":
      window.location.href = "/rti.html";
      break;
    case "Legal Protection Plan":
      window.location.href = "/legal-protection-plan.html";
      break;
    case "NRI and Overseas Indians Help Desk":
      window.location.href = "/nri-and-overseas-indians-help-desk.html";
      break;
    case "Consumer complaint":
      window.location.href = "/consumer-complaint.html";
      break;

    default:
      console.log(`Navigation for ${item} not implemented yet`);
  }
};
const Header = () => {
  const token = localStorage.getItem("token");
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [expandedItems, setExpandedItems] = React.useState<{
    [key: string]: boolean;
  }>({});

  const currentDateTime = dayjs().format("D MMM, YYYY / h:mmA");

  const handleDrawerClick = (event: any) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (event: any) => {
    if (isMobile) {
      setDrawerOpen(true);
    }
    // Remove TypeScript type
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleExpandClick = (itemLabel: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemLabel]: !prev[itemLabel],
    }));
  };

  // Navigation items from DesktopNav
  const navItems = [
    {
      id: "legalServices",
      label: "Legal Services",
      hasDropdown: true,
      submenu: [
        "Legal Notice- Send and Reply",
        "Legal Drafting",
        "Legal Document Review",
        "File or Defend a Case",
        "Talk to a Lawyer"
      ],
    },
    {
      id: "legalFinance",
      label: "Legal Finance",
      hasDropdown: true,
      submenu: ["Third Party Litigation Funding", "New Feature-Coming Soon"],
    },
    {
      id: "odr",
      label: "Online Dispute Resolution",
      hasDropdown: true,
      submenu: ["Online Mediation", "Online Arbitration"],
    },
    {
      id: "talkExpert",
      label: "Talk with an Expert",
      hasDropdown: true,
      submenu: [
        "Talk to a Lawyer",
        "Talk to a Chartered Accountant",
        "Talk to a Company Secretary"
      ],
    },
    {
      id: "startupSupport",
      label: "Start-up Support Service",
      hasDropdown: true,
      submenu: [
        "Incorporate your Business",
        "Start-up Tool Kit",
        "Fund Raising",
        "DPDP Compliance",
        "Pitch Deck",
        "Due-Diligence",
        "Virtual Legal Counsel",
        "Website Development Services",
        "Posh Compliance"
      ],
    },
    {
      id: "businessReg",
      label: "Business Registration",
      hasDropdown: true,
      submenu: [
        "Register Private Limited Company",
        "Register Limited Liability Partnership (LLP)",
        "Register Subsidiary Company",
        "Register Producer Company",
        "Register One Person Company",
        "Register Nidhi Company",
        "Register Sole Proprietorship",
        "Register Partnership"
      ],
    },
    {
      id: "forInvestors",
      label: "For Investors",
      hasDropdown: true,
      submenu: [
        "Alternative Fund Incubation",
        "Investment Execution Advisory",
        "Investment Transaction Life Cycle",
        "Exit Support and Compliance"
      ],
    },
    {
      id: "taxCompliance",
      label: "Tax & Compliance",
      hasDropdown: true,
      submenu: [
        "Income Tax Return Filling",
        "TDS Return Filling",
        "GST Registration Online",
        "GST Filling Online",
        "Annual Accounting services",
        "Licenses and Registration",
        "Changes in Private Limited Company",
        "Changes in LLP",
        "Business Entity Conversion",
        "Secretarial Audit",
        "Register Copyright",
        "Register Patent",
        "Register Trademark",
        "Register your Design",
        "IP-Infringement"
      ],
    },
    {
      id: "otherServices",
      label: "Other Services",
      hasDropdown: true,
      submenu: [
        "NGO Registration and Compliance",
        "File RTI Application",
        "Virtual Legal Counsel",
        "Legal Protection Plan",
        "NRI and Overseas Indians Help Desk",
        "Consumer complaint"
      ],
    },
  ];

  return (
    <Box
      sx={{
        position: "sticky",
        // position: "fixed",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      {/* Top Bar */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: ColorData.primary.main, // Your theme color
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            minHeight: "none !important",
          }}
        >
          <Grid
            className="test1"
            width={"100%"}
            container
            alignItems="center"
            justifyContent={"space-between"}
            spacing={2}
          >
            {/* Left Side: Call Info */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    mr: 1,
                    borderRadius: "50%",
                    border: "1px solid white", // white border
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PhoneIcon sx={{ fontSize: "14px" }} /> {/* icon 14px */}
                </Box>
                <Typography
                  color="background.default"
                  sx={{ fontSize: "14px" }}
                >
                  Call Us&nbsp;${Admin_Number}
                </Typography>
              </Box>
            </Grid>

            {/* Center: Search Box */}
            {!isMobile && (
              <Grid
                size={{ md: 4, lg: 4 }}
                display="flex"
                justifyContent="center"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    px: 1,
                    width: "18.125rem",
                    maxWidth: 500,
                  }}
                >
                  <SearchIcon sx={{ color: ColorData.primary.main }} />
                  <InputBase placeholder="Search..." sx={{ ml: 1, flex: 1 }} />
                </Box>
              </Grid>
            )}

            {/* Right Side */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
                flexWrap="nowrap"
              >
                {!isMobile && (
                  <>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      {currentDateTime}
                    </Typography>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Download App
                    </Typography>

                    <LanguageSelector />
                  </>
                )}
                {token ? (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate("/dashboard")}
                  >
                    {myInfo.firstname}
                  </Button>
                ) : (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate(RouteUrls.login)}
                  >
                    Login
                  </Button>
                )}

                <IconButton onClick={handleDrawerClick} sx={{ color: "#fff" }}>
                  <MenuIcon />
                </IconButton>
                <MenuList
                  menuAnchorEl={menuAnchorEl}
                  handleMenuClose={handleMenuClose}
                />
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* Bottom Header / Logo + Menu */}
      <AppBar
        position="static"
        color="transparent"
        elevation={1}
        sx={{
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          backgroundColor: "#fff",
          color: "#000",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar className="TEst">
          <Box
            component="img"
            src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
            alt="Logo"
            sx={{
               width: { xs: "150px", sm: "200px", md: "100px" },
              height: { xs: "60px", sm: "80px", md: "83px" },
              objectFit: "contain",
              cursor: "pointer",
              filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
            onClick={() => navigate("/")}
          />
          <Box
            sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}
          >
            {!isMobile && (
              <DesktopNav navItems={navItems} onNavigate={handleNavigation} />
            )}
            {isMobile && (
              <IconButton
                onClick={handleMenuClick}
                sx={{ color: ColorData.text.primary }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <MobileDrawer
        open={drawerOpen}
        onClose={toggleDrawer}
        navItems={navItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={handleNavigation}
      />
    </Box>
  );
};

export default Header;
